import React from 'react';
import { motion } from 'framer-motion';

export default function Contact() {
  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.3, delayChildren: 0.2 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 80 } },
  };

  return (
    <section
      id="contact"
      className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-tr from-indigo-100 to-purple-200 px-6 md:px-20 py-20"
    >
      <motion.div
        className="max-w-md text-center"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h2 className="text-4xl font-bold mb-6 text-indigo-900" variants={itemVariants}>
          Get in Touch
        </motion.h2>
        <motion.p className="mb-6 text-lg text-indigo-800" variants={itemVariants}>
        I’d love to hear from you!
        </motion.p>
        <motion.p className="mb-6 text-lg text-indigo-800" variants={itemVariants}>

Whether you have a project in mind, need a designer or developer for your team, or just want to say hello—feel free to reach out. I'm always open to new ideas, collaborations, and opportunities.


        </motion.p>
        <motion.p className="mb-6 text-lg text-indigo-800" variants={itemVariants}>
        You can contact me via:
        </motion.p>
        <motion.div className="space-y-5 text-indigo-700 text-left" variants={itemVariants}>
          {/* Email */}
          <div className="flex items-center space-x-3">
            <svg className="w-6 h-6 text-indigo-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M4 4h16v16H4z" fill="none" />
              <path d="M20 4H4v16h16V4zm-2 4l-6 4.5L6 8V6l6 4.5L18 6v2z" />
            </svg>
            <a href="mailto:bekiabi90@gmail.com" className="hover:underline">
              bekiabi90@gmail.com
            </a>
          </div>

          {/* Phone */}
          <div className="flex items-center space-x-3">
            <svg className="w-6 h-6 text-indigo-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M6.62 10.79a15.464 15.464 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.11-.21c1.12.45 2.33.69 3.48.69.55 0 1 .45 1 1v3.5c0 .55-.45 1-1 1C10.29 21 3 13.71 3 4.5c0-.55.45-1 1-1H7.5c.55 0 1 .45 1 1 0 1.15.24 2.36.69 3.48.15.39.05.84-.21 1.11l-2.2 2.2z" />
            </svg>
            <a href="tel:+251961704264" className="hover:underline">
              +251 961704264
            </a>
          </div>

          {/* LinkedIn */}
          <div className="flex items-center space-x-3">
            <svg className="w-6 h-6 text-indigo-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 0h-14c-2.75 0-5 2.25-5 5v14c0 2.75 2.25 5 5 5h14c2.75 0 5-2.25 5-5v-14c0-2.75-2.25-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.27c-.97 0-1.75-.78-1.75-1.73s.78-1.75 1.75-1.75 1.73.78 1.73 1.75-.76 1.73-1.73 1.73zm13.5 11.27h-3v-5.6c0-1.33-.03-3.04-1.85-3.04s-2.14 1.45-2.14 2.95v5.69h-3v-10h2.89v1.36h.04c.4-.75 1.39-1.54 2.85-1.54 3.05 0 3.62 2.01 3.62 4.62v5.56z" />
            </svg>
            <a
              href="https://www.linkedin.com/in/bereket-assefa-769361285"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              LinkedIn
            </a>
          </div>

          {/* Facebook (optional) */}
          <div className="flex items-center space-x-3">
            <svg className="w-6 h-6 text-indigo-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22 12c0-5.522-4.478-10-10-10S2 6.478 2 12c0 5.005 3.662 9.128 8.438 9.878v-6.988h-2.54v-2.89h2.54V9.845c0-2.506 1.493-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.464h-1.26c-1.243 0-1.63.772-1.63 1.562v1.877h2.773l-.443 2.89h-2.33v6.988C18.338 21.128 22 17.005 22 12z" />
            </svg>
            <a
              href="https://www.facebook.com/profile.php?id=100034353260046"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Facebook
            </a>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
